import React from 'react';
import { TestResultType2Bypass } from '@ecosconnect/core/src/types/jobFormData';
import AccordionItem from '../../../Accordion/AccordionItem';
import { formatDecimal } from '@ecosconnect/core/src/helpers/number';

const Type2BypassTestResult: React.FC<{ test: TestResultType2Bypass }> = ({
  test,
}) => {
  return (
    <AccordionItem
      label="Bypass Check"
      value={formatDecimal(test.bypassCheck)}
    />
  );
};

export default Type2BypassTestResult;
